module.exports = __webpack_public_path__ + "media/newstyle/images/icon-cross-purple-6861ff122f496be8f94b7adfeb5c43ba.svg";